import 'babel-polyfill';
import React from "react";
import { Button, message } from "antd";
import screenshots from './screenshots'; // Import screenshot list
import axios from 'axios';
let REACT_APP_USERNAME="18371263340"
let REACT_APP_PASSWORD="xytechsz"
class ShensikaoAI extends React.Component {
  constructor() {
    super();
    this.state = {
      screenshots: screenshots,
      enlargedImage: null,
      selectedScreenshot: null,
      analysisResult: null,
    };
  }

  handleScreenshotClick = (screenshot) => {
    this.setState({ selectedScreenshot: screenshot, enlargedImage: screenshot, analysisResult: null });
    this.clearCanvas(this.canvasRef)
  };

    handleAnalyzeClick = async () => {
      if (!this.state.selectedScreenshot) {
          console.warn('No selected screenshot to analyze');
          return;
      }
  
      const base64Image = this.state.selectedScreenshot;
      console.log(REACT_APP_PASSWORD)
      try {
          // 提取 Base64 数据部分
          const base64PrefixRegex = /^data:image\/(png|jpeg|gif);base64,/;
          const match = base64Image.match(base64PrefixRegex);
          if (!match) {
              console.error('Unexpected or unsupported base64 prefix');
              return;
          }
          const imageData = base64Image.substring(match[0].length);
  
          // 登录请求
          const loginResponse = await axios.post(
              'https://tct.shensikao.com/aieye2-full/login',
              {
                  cameraInfo: "2LpoHU6Z7LLoTpApV12onodiMsVtBmqD8uyGWvdqUSJoZjuVBYL4qmrhpjeJXXzZVmthV9GRe2f6yLNa2SdHTFVN3Qmsijo8FEPEXmJRvoEmN4",
                  password:REACT_APP_PASSWORD, // 使用环境变量存储敏感信息
                  username:REACT_APP_USERNAME,
              },
              {
                  headers: {
                   
                  },
              }
          );
  
          if (!loginResponse || !loginResponse.token) {
              throw new Error('Login failed: Token not found in response');
          }
  
          const token = loginResponse.token;
  
          // 创建 FormData 对象并添加字段
          const formData = new FormData();
          formData.append('imageData', imageData);
  
          // 图片分析请求
          const analysisResponse = await axios.post(
              'https://tct.shensikao.com/aieye2-full/cell_dec?module=TCT&subModule=&ob=',
              formData,
              {
                  headers: {
                      'Authorization': `Bearer ${token}`,
                  },
              }
          );
  
          // 更新状态
          this.setState(
              { analysisResult: analysisResponse },
              () => message.success('图片分析完成') // 确保状态更新完成后显示成功消息
          );
      } catch (error) {
          console.error('Error during image analysis:', error.message);
          message.error('图片分析失败，请稍后再试');
      }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.analysisResult !== this.state.analysisResult) {
      const canvas = this.canvasRef;
      if (canvas) {
        this.drawAnnotations(canvas, this.state.analysisResult);
      }
    }
  }
  // 清除画布的方法
clearCanvas = (canvas) => {
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
};
drawAnnotations = (canvas, analysisResult) => {
  if (!canvas || !analysisResult) return;

  const ctx = canvas.getContext('2d');

  const img = new Image();
  img.src = this.state.enlargedImage;
  img.onload = () => {
    // 获取图片的显示宽度
    const displayWidth = 750/img.naturalWidth* img.naturalWidth;
    const scaleRatioX = displayWidth / img.naturalWidth;
    const scaleRatioY = scaleRatioX; // Maintain aspect ratio
    
    canvas.width = displayWidth ;
    canvas.height = img.naturalHeight * scaleRatioY;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    analysisResult.cells.forEach(cell => {
      const x = cell.x * scaleRatioX;
      const y = cell.y * scaleRatioY;
      const width = cell.width * scaleRatioX;
      const height = cell.height * scaleRatioY;

      ctx.strokeStyle = cell.stroke;
      ctx.lineWidth = 2;
      ctx.strokeRect(x, y, width, height);
      ctx.fillText(cell.text, x + 5, y - 5);
    });
  };
};

  render() {
    const { screenshots, enlargedImage, analysisResult } = this.state;

    return (
      <div className="shensikao-ai-container">
        <h1 style={{ fontSize: '28px', fontWeight: '700', margin: '20px 0' }}>昕昱科技AI分析</h1>
        <hr style={{
          width: '100%',
          margin: '0 0 20px 0',
          border: 'none',
          borderTop: '1px solid #ccc',
          alignSelf: 'flex-start'
        }} />

        <div className="main-content" style={{
          display: 'flex',
          gap: '32px',
          justifyContent: 'space-between'
        }}>
          {/* Left Panel */}
          <div className="left-panel" style={{
            flex: 1,
            maxWidth: '10%',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
          }}>
            <ul className="screenshot-list" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
              gap: '16px',
              padding: 0,
              listStyle: 'none',
              overflowY: 'auto',
              maxHeight: 'calc(100vh - 62px)',
              boxSizing: 'border-box'
            }}>
              {screenshots.map((screenshot, index) => (
                <li key={index} onClick={() => this.handleScreenshotClick(screenshot)}
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #eee',
                    borderRadius: '4px',
                    boxSizing: 'border-box'
                  }}>
                  <img
                    src={screenshot}
                    style={{
                      width: '100%',
                      height: 'auto',
                      padding: "10px",
                      objectFit: 'cover'
                    }}
                    alt={`Screenshot ${index + 1}`}
                    className="thumbnail" />
                </li>
              ))}
            </ul>
          </div>

          {/* Right Panel */}
          <div className="right-panel" style={{
            flex: 1,
            maxWidth: '70%',
            borderLeft: '1px solid #ccc',
            paddingLeft: '32px'
          }}>
            {enlargedImage && (
              <div className="enlarged-image-container">
                <div className="controls" style={{ marginBottom: '20px' }}>
                  <Button type="primary" onClick={this.handleAnalyzeClick}>AI 分析</Button>
                </div>
                <div style={{ position: 'relative', marginBottom: '20px' }}>
                  <canvas
                    ref={canvas => this.canvasRef = canvas}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      zIndex: 1
                    }}></canvas>
                  <img
                    src={enlargedImage}
                    style={{
                      width: '750px',
                      height: 'auto',

                      border: '1px solid #eee',
                      borderRadius: '4px',
                      position: 'relative',
                      zIndex: 0
                    }}
                    alt="Enlarged Screenshot"
                    className="enlarged-image" />
                </div>
              </div>
            )}
          </div>

          {/* Analysis Result Panel */}
          <div className="result-panel" style={{
            flex: 1,
            maxWidth: '20%',
            borderLeft: '1px solid #ccc',
            paddingLeft: '32px'
          }}>
            {analysisResult && (
              <div className="analysis-result" style={{
                padding: '20px',
                background: '#f5f5f5',
                borderRadius: '4px'
              }}>
                <h3 style={{ marginTop: 0 }}>分析结果:</h3>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  {analysisResult.cells.map((cell, index) => (
                    <li key={index}>
                      {`${cell.text}`}
                    </li>
                  ))}
                </ul>
                <p>总细胞数: {analysisResult.diseasedCellsCount}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ShensikaoAI;


